import { useRef, useEffect, useState } from "react";
import './policies.css';
import * as aserver from '../../APIClient';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';

const SigningInput = (props) => {
    return (
        <div style={{marginTop:"1em"}}>
            
            <label htmlFor={props.field} dangerouslySetInnerHTML={{ __html: props.title }}></label>
            <input type="text" maxLength={props.maxlen} name={props.field} id={props.field} value={props.data[props.field]} onChange={() => { }} required />
        </div>
    )
}

const PolicyViewer = (props) => {

    const pathname = window.location.pathname;
    let sections = pathname.split('/');
    const policyUUID = sections.pop();
    const coachUUID = sections.pop();

    const [policy, setPolicy] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [signed, setSigned] = useState(false);
    const [inputData, setInputData] = useState({
        coachTypedName: "",
        coachTypedDate: "",
    });

    function getFields(policy) {
        let fields  = policy.extraFields.map(ef=>ef.name);
        fields.push('coachTypedName');
        fields.push('coachTypedDate');
        fields.push('coachSignedAt');
        fields.push('coachSignedAtLocal');
        fields.push('aephoriaTypedName');
        fields.push('aephoriaSignedAtLocal');
        return(fields);
    }

    function allFieldsFilledIn() {
        if ((policy.ackMethod==='none')||(policy.ackMethod==='click'))
            return(true)
        if ((!inputData.coachTypedName)||(!inputData.coachTypedDate))
            return(false)
        for (let ef of policy.extraFields) {
            if (!inputData[ef.name])
                return(false)
        }
        return(true)
    }

    function fillPolicy(policy, data, signed) {
        console.log(data);
        let fields = getFields(policy);
        policy.content = policy.original;
        if (!signed) {
            let bits = policy.content.split('<!--sign--->');
            policy.content = [bits[0],bits[2]].join('');
        }
        for (let field of fields) {
            if (data[field])
                policy.content = policy.content.replaceAll('{' + field + '}', `<b>${data[field]}</b>`);
        }
        for (let field of fields) {
            if (data[field])
                policy.welcomeMessage.afterSigning = policy.welcomeMessage.afterSigning.replaceAll('{' + field + '}', `<b>${data[field]}</b>`);
        }
    }

    useEffect(() => {
        async function getPolicies() {
            try {
                let response = await aserver.get(`api/v2/coaches/${coachUUID}/policy/${policyUUID}`);
                response.data.policy.original = response.data.policy.content;
                let data = inputData;
                if (response.data.policy.policyCoach) {
                    let fields = getFields (response.data.policy);
                    for (let field of fields) {
                        data[field] = response.data.policy.policyCoach[field]
                    }
                }
                let signed = (response.data.policy.ackMethod==='none')||response.data.policy.policyCoach.coachSignedAt;
                setInputData(data);
                fillPolicy(response.data.policy, data, signed);
                setPolicy(response.data.policy);
                setSigned(signed);
                console.log(response.data.policy);
            } catch (err) {
                console.log(err)
            }
        };
        getPolicies();
    }, []);

    function handleInputDataChange(event) {
        if (event.target.nodeName === 'INPUT') {
            let rdata = { ...inputData };
            rdata[event.target.name] = event.target.value;
            setInputData(rdata)
            fillPolicy(policy, rdata, signed);
        }
    }

    async function onSigningSubmit() {
        setWaiting(true);
        try {
            inputData.coachSignedAtLocal = new Date().toString();
            let response = await aserver.post(`api/v2/coaches/${coachUUID}/policy/${policyUUID}`, inputData);
            localStorage.setItem(policy.code, 'done');
            window.location.reload(false)
        } catch (err) {
            setWaiting(false)
        }
    }

    return (
        <div className='policyContainer'>
            <CssBaseline />
            {!policy ? <>Loading...</> : <>

                <div class="welcomeMessage noPrint">
                    {!signed && <div>{policy.welcomeMessage.beforeSigning}</div>}
                    {signed && <div dangerouslySetInnerHTML={{ __html: policy.welcomeMessage.afterSigning }}></div>}
                    <div><br></br>Note: for your future reference, you can save a copy of this document as a PDF by using your browser's Print function, where you can specify "Save as PDF" (exact wording may vary by browser), and then when prompted, choose where you want to save the file.</div>
                </div>

                {!signed && <div onChange={handleInputDataChange}>
                    {policy.extraFields && policy.extraFields.map((ef, index) =>
                        <SigningInput title={ef.caption} field={ef.name} data={inputData} maxlen={800} />
                    )}
                </div>}

                <div className='policyContent' dangerouslySetInnerHTML={{ __html: policy.content }}></div>

                <>
                    {!signed && <div>

                        {(policy.ackMethod === 'sign') && <div>
                            <h3 className="heading">Signing</h3>
                            <div onChange={handleInputDataChange}>
                                <SigningInput title="Type your own name" field='coachTypedName'  maxlen={800} data={inputData} />
                                <br></br>
                                <SigningInput title="Type today's date" field='coachTypedDate' maxlen={100} data={inputData} />
                                <br></br>
                            </div>
                        </div>}

                        <div className="navButtons">
                                <Button variant="contained" disabled={waiting||!allFieldsFilledIn()} color="primary" onClick={() => onSigningSubmit()}>{waiting?'Please wait...':((policy.ackMethod==='sign')?'Sign':'Accept')}</Button>
                        </div>

                    </div>}

                </>

            </>}
        </div>
    )
};

export default PolicyViewer;
